<template>
  <div class="-pt-5 -px-5">
    <div class="-pb-5 -border-bottom">
      <h3 class="-h3">{{$t('common.user_info')}}</h3>
      <div class="-wrapper-between -px-5">
        <div class="-div-table">
          <div class="-row">
            <div class="-row-header">
              <h5 class="-font-size-12 txt-center">{{$t('common.user_name')}}</h5>
            </div>
            <div class="-row-contents">
              <p class="-wrapper-v-center">
                <span class="-paragraph -ml-1 -font-size-14" id="customer-bespin-customername">{{selectedUserInfo.userName}}</span>
              </p>
            </div>
          </div>
          
        </div>

        <div class="-div-table -ml-5">
          <div class="-row">
            <div class="-row-header">
              <h5 class="-font-size-12 txt-center">{{$t('common.email')}}</h5>
            </div>
            <div class="-row-contents">
              <p class="-wrapper-v-center">
                <span class="-paragraph -ml-1 -font-size-14" id="customer-bespin-customername">{{selectedUserInfo.userEmail}}</span>
              </p>
            </div>
          </div>
          
        </div>
        
      </div>

      <div class="-bg-white ">
        <div class="-tile-container">
          <div class="-div-table -px-5 -pb-5">
            <div class="-row">
              <ag-grid-vue id="company-popup-ag-grid-vue"
                style="height: 150px;border-top:none;border-left:none; border-right:none"
                class="ag-theme-balham -border"
                row-height="30"
                header-height="30"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :gridOptions="gridOptions"
                :rowData="groups"
                :overlayLoadingTemplate="overlayLoadingTemplate"
                :loadingOverlayComponent="loadingOverlayComponent"
                :loadingOverlayComponentParams="loadingOverlayComponentParams"
                :overlayNoRowsTemplate="overlayNoRowsTemplate"
                :noRowsOverlayComponent="noRowsOverlayComponent"
                :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
                :frameworkComponents="frameworkComponents"
                :modules="modules"
                :pagination="false"
                :suppressPaginationPanel="true"
                :suppressScrollOnNewData="true"
                @grid-ready="onGridReady"
              >
              </ag-grid-vue>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="-wrapper-between">
      <div style="width:30%">
        <h3 class="-h3 -pt-5">{{$t('pages_user_UserCreateAccount.settingAuth')}}</h3>
        <div class=" -px-5 -pt-5" >
          <g-dropdown
            id="customer-list-auth"
            dropdown-type="button"
            variant="secondary"
            class="-width-50"
            style="width:180px"
            @change="onChangeAuth"
            v-model="inputUserInfo.auth">
            <g-dropdown-item-wrap>
              <g-dropdown-item
                v-for="group in allGroupList"
                :key="group.key"
                :text="group.name"
                :value="group.key"
              />
            </g-dropdown-item-wrap>
          </g-dropdown>
        </div>

        <div class="-label -width-100 -pb-8" v-if="isCustomerUser" v-show="false">
          <h3 class="-h3 -pt-5">{{$t('common.position_name')}}</h3>
          <div class=" -px-5 -pt-3">
            <g-input-text
              id="customer-portal-deptname"
              class="-width-50 "
              maxlength="20"
              style="width:180px"
              :placeholder="$t('pages_user_UserCreateAccountSelectManager.placeholder.2')"
              v-model="inputUserInfo.duty"
            />
          </div>
        </div>

        <div class="-label -width-100" v-if="isBespinMiddleManager">
            <div class="-wrapper">
              <p class="-h3 -pt-5">{{$t('common.middle_group')}}</p>
            </div>
            <div class="-splitted-wrap -px-5 -pt-5">
              <g-dropdown
                id="customer-bespin-middlemanager"
                dropdown-type="button"
                variant="secondary"
                text-align="start"
                style="width:160px"
                v-model="inputUserInfo.leader">
                <g-dropdown-item-wrap>
                  <g-dropdown-item
                    v-for="group in middleGroupList"
                    :key="group.codeId"
                    :text="group.codeName"
                    :value="group.codeId"/>
                </g-dropdown-item-wrap>
              </g-dropdown>
            </div>
          </div>

      </div>

      <div style="width:70%">
        <div class="-wrapper-tile" >
          <div class="-header -pt-5">
            <p class="-h3">{{$t('common.company_info')}}</p>
            <g-button  class="-mb-2" variant="primary" size="small" id="company-info-select-button" @click="onClickSelectCustomer" v-if="!innerUserInfo">
              <span>{{$t('pages_user_UserCreateAccount.4')}}</span>
            </g-button>
          </div>
        </div>
        <div class="-tile-container">
          <div class="-div-table -px-5 -pb-5">
            <div class="-row">
              <div class="-row-header -pl-4">
                <h5 class="-font-size-12 txt-center">{{$t('common.company_name')}}</h5>
              </div>
              <div class="-row-contents">
                <p class="-wrapper-v-center">
                  <span class="-paragraph -ml-1 -font-size-14" id="customer-info-customerName">
                    {{inputUserInfo.customerName}}
                  </span>
                </p>
              </div>
            </div>
            
            <div class="-row">
              <div class="-row-header -pl-4">
                <h5 class="-font-size-12 txt-center">{{$t('common.company_dept_name')}}</h5>
              </div>
              <div class="-row-contents">
                <p class="-wrapper-v-center">
                  <span class="-paragraph -ml-1 -font-size-14" id="customer-info-deptName">
                    {{inputUserInfo.deptName}}
                  </span>
                </p>
              </div>
            </div>

            <div class="-row">
              <div class="-row-header -pl-4">
                <h5 class="-font-size-12 txt-center">{{$t('common.company_no')}}</h5>
              </div>
              <div class="-row-contents">
                <p class="-wrapper-v-center">
                  <span class="-paragraph -ml-1 -font-size-14" id="customer-info-company_no">
                    {{inputUserInfo.customerRegisNo}}
                  </span>
                </p>
              </div>
            </div>

            <div class="-row">
              <div class="-row-header -pl-4">
                <h5 class="-font-size-12 txt-center">{{$t('common.post_no')}}</h5>
              </div>
              <div class="-row-contents">
                <p class="-wrapper-v-center">
                  <span class="-paragraph -ml-1 -font-size-14" id="customer-info-post_no">
                    {{inputUserInfo.pos}}
                  </span>
                </p>
              </div>
            </div>

            <div class="-row">
              <div class="-row-header -pl-4">
                <h5 class="-font-size-12 txt-center">{{$t('pages_user_CustomerInfo.company.2')}}</h5>
              </div>
              <div class="-row-contents">
                <p class="-wrapper-v-center">
                  <span class="-paragraph -ml-1 -font-size-14" id="customer-info-pos">
                    {{inputUserInfo.city}}
                  </span>
                </p>
              </div>
            </div>

            <div class="-row">
              <div class="-row-header -pl-4">
                <h5 class="-font-size-12 txt-center">{{$t('common.address')}}</h5>
              </div>
              <div class="-row-contents">
                <p class="-wrapper-v-center">
                  <span class="-paragraph -ml-1 -font-size-14" id="customer-info-address">
                    {{inputUserInfo.locD}}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { AgGridVue } from 'ag-grid-vue';
import {ValidationProvider} from 'vee-validate'
import { AUTH_GROUP } from '@/constants/constants'
import {MARKET_SERVICE_CODE} from "@/constants/constants";
import AgGridMixin from '../../mixin/AgGrid.mixin'
import CustomerListPopup from "./CustomerListPopup.vue"

export default {
  components: {
    ValidationProvider,
    AgGridVue
  },
  props: {
    selectedUserInfo: {
      type: Object
    }
  },
  mixins: [AgGridMixin()],
  data () {
    return {
      innerUserInfo: null,
      allGroupList: [],
      inputUserInfo: {
        city: '',
        customerCode: '',
        customerName: '',
        customerRegisNo: '',
        deptCode: '',
        deptName: '',
        empNo: '',
        locD: '',
        pos: '',
        auth: '',
        leader: '',
        userEmail: '',
        firstName: '',
        lastName: '',
        userTelNo: '',
        userTelNoCtrCd: '',
        duty: '',
        idpStatus: ''
      },
      columnDefs: [],
      defaultColDef: {},
      gridOptions: null,
      thisSearchName: '',
      groups: [],
    }
  },
  computed: {
    ...mapGetters('code', ['userGroupList', 'middleGroupList']),
    ...mapGetters('customer', ['groupList']),
    ...mapGetters('user', ['userInfo']),
    isBespinMiddleManager () {
      return this.inputUserInfo.auth === AUTH_GROUP.BespinMiddleManager
    },
    isCustomerUser () {
      return this.inputUserInfo.auth === AUTH_GROUP.AccountManager
    }
  },
  methods: {
    ...mapActions('user', ['getIDPUserList', 'getUserGroup', 'getInnerUserInfo']),
    onChangeAuth (id) {
      this.inputUserInfo.auth = id
    },
    onRowDataChanged () {
      this.fitGrid()
    },
    setColumn () {
      this.columnDefs = [
        {
          headerName: this.$t('pages_user_UserCreateAccount.userGroups'),
          field: "groupName",
          width: 40,
          sortable: true,
          unSortIcon: true,
          getQuickFilterText: params => {
            return params.data.groupName
          },
          cellRenderer: params => {
            return params.data.groupName.concat('(',params.data.companyName,')')
          }
        }
      ];
      this.fitGrid()
    },
    onGridReady(params) {
      this.setGridParams(params)
      this.setGridParams(params)
      this.fitGrid()
    },
    bindInnerUserData() {
      if(this.innerUserInfo && this.innerUserInfo.cusDept){
          this.inputUserInfo.customerCode = this.innerUserInfo.cusDept.customerCode
          this.inputUserInfo.customerName = this.innerUserInfo.cusDept.customerName
          this.inputUserInfo.deptCode = this.innerUserInfo.departmentCode
          this.inputUserInfo.deptName = this.innerUserInfo.cusDept.deptName
          this.inputUserInfo.empNo = this.innerUserInfo.employeeCode
          this.inputUserInfo.locD = this.innerUserInfo.cusDept.locD
          this.inputUserInfo.pos = this.innerUserInfo.cusDept.pos
          this.inputUserInfo.customerRegisNo = this.innerUserInfo.cusDept.customerRegistorNo
          this.inputUserInfo.city = this.innerUserInfo.cusDept.city
        }
    },
    
    onClickSelectCustomer() {

      this.$popupManager.open(CustomerListPopup, {
        onSend: (selectedValue) => {
          this.inputUserInfo.customerCode = selectedValue.customerCode
          this.inputUserInfo.customerName = selectedValue.customerName
          this.inputUserInfo.deptCode = selectedValue.customerDeptCode.replace(selectedValue.customerCode + "|", "")
          this.inputUserInfo.deptName = selectedValue.deptName
          this.inputUserInfo.locD = selectedValue.locD
          this.inputUserInfo.pos = selectedValue.pos
          this.inputUserInfo.customerRegisNo = selectedValue.customerRegistorNo
          this.inputUserInfo.city = selectedValue.city
        }
      })
    },
  },
  watch: {
    inputUserInfo: {
      handler () {
        this.$emit('change', this.inputUserInfo)
      },
      deep: true
    }
  },
  beforeMount (){
  // bind  auth combo value
    var that = this;
    //get PortalGate User Groups
    this.getUserGroup({
      serviceCode: MARKET_SERVICE_CODE,
      siteCode: that.userInfo.siteCode,
      userEmail: that.selectedUserInfo.userEmail
    }).then(function(data){
      that.groups = data.items
    })
  },
  mounted () {
    var that = this;
    var allGroupList = this.groupList.concat();
    //check if can find userEmail in employee
    this.getInnerUserInfo({userEmail: this.selectedUserInfo.userEmail}).then(function(data){
        if(data && data.cusDept){
          that.innerUserInfo = data
          that.bindInnerUserData()

          allGroupList.unshift({
            key:  "",
            id: "",
            name: that.$t("common.select")
          })
          allGroupList = allGroupList.filter(g => g.id != AUTH_GROUP.AccountManager)
        }else{
          allGroupList = allGroupList.filter(g => g.id == AUTH_GROUP.AccountManager)
          if (allGroupList.length === 1) {
            that.inputUserInfo.auth = allGroupList[0].key
          }else{
            allGroupList.unshift({
              key:  "",
              id: "",
              name: that.$t("common.select")
            });
          }
        }
        that.allGroupList = allGroupList
        that.inputUserInfo.userEmail = that.selectedUserInfo.userEmail
        that.inputUserInfo.userTelNo = that.selectedUserInfo.userTelNo
        that.inputUserInfo.userName = that.selectedUserInfo.userName
        that.inputUserInfo.firstName = that.selectedUserInfo.firstName
        that.inputUserInfo.lastName = that.selectedUserInfo.lastName
        that.inputUserInfo.userTelNoCtrCd = that.selectedUserInfo.userTelNoCtrCd
        that.inputUserInfo.idpStatus = that.selectedUserInfo.useYn == 'Y' ? 'ACTIVE' : "DEACTIVE"
    });
  }

}
</script>


// WEBPACK FOOTER //
// src/pages/user/components/UserCreateAccountInputInfo.vue